"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
require("antd/dist/antd.css");
var _antd2 = require("antd");
require("./customModal.scss");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const CustomModal = _ref => {
  let {
    userStatusData,
    modalVariant
  } = _ref;
  const ModalComponent = () => {
    switch (modalVariant) {
      case "statusModal":
        return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_antd2.Modal, {
          visible: "true",
          closable: false,
          okButtonProps: {
            style: {
              display: 'none'
            }
          },
          cancelButtonProps: {
            style: {
              display: 'none'
            }
          },
          getContainer: "#modalMount"
        }, userStatusData.modalHeaderText && /*#__PURE__*/_react.default.createElement("div", {
          className: "cust-modal-title-text"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "statusText-Modal"
        }, /*#__PURE__*/_react.default.createElement("span", {
          style: {
            color: "#4A7B09"
          }
        }, "Active"), " ", userStatusData.active), /*#__PURE__*/_react.default.createElement("div", {
          className: "statusText-Modal"
        }, /*#__PURE__*/_react.default.createElement("span", {
          style: {
            color: "#FA6400"
          }
        }, "Invitation Pending"), " ", userStatusData.Invitation_Pending), /*#__PURE__*/_react.default.createElement("div", {
          className: "statusText-Modal"
        }, /*#__PURE__*/_react.default.createElement("span", {
          style: {
            color: "#E00932"
          }
        }, "Invitation Expired"), " ", userStatusData.Invitation_Expired), /*#__PURE__*/_react.default.createElement("div", {
          className: "statusText-Modal"
        }, /*#__PURE__*/_react.default.createElement("span", {
          style: {
            color: "#0B3471"
          }
        }, "In Process"), " ", userStatusData.In_Process), /*#__PURE__*/_react.default.createElement("div", {
          className: "statusText-Modal"
        }, /*#__PURE__*/_react.default.createElement("span", {
          style: {
            color: "#FA6400"
          }
        }, "Email Verification Pending"), " ", userStatusData.Email_Updated))), /*#__PURE__*/_react.default.createElement("div", {
          id: "modalMount",
          class: "statusModalClass"
        }));
      default:
        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
    }
  };
  return ModalComponent();
};
var _default = exports.default = CustomModal;